import { SET_PAYMENT } from "@/store/types";

export default {
  namespaced: true,
  state: {
    paymentPopup: false,
  },
  getters: {
    getPopup(state) {
      return state.paymentPopup;
    },
  },
  mutations: {
    [SET_PAYMENT]: (state, payload) => {
      state.paymentPopup = payload;
    },
  },
  actions: {
    setPaymentPopup({ commit }, payload) {
      commit(SET_PAYMENT, payload);
    },
  },
};
